<footer>
    <div>&copy; {{ currentYear }} New Wave Schools</div>
    <div class="build-info">
        @if (showTag) {
            <span>v{{ tag }}</span>
        }
        @if (showTime) {
            <span>v{{ time }}</span>
        }
    </div>
</footer>
